module.exports = __webpack_public_path__ + "static/media/error.1c44c27d.png";